"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Home, Library, Plus, Heart, Calendar } from "lucide-react";

export default function MobileNav() {
  const pathname = usePathname() ?? "";

   const hideNav = [
    "/",
    "/login",
    "/signup",
    "/forgot-password",
    "/reset-password",
    "/marketing/opt-in",
    "/privacy",
    "/terms",
  ].includes(pathname);

  if (hideNav) return null;

  const linkClass = (path: string) => {
    const active = path === "/bookbesties" ? pathname.startsWith("/bookbesties") : pathname === path;
    return [
      "flex items-center justify-center rounded-2xl p-3 transition-all duration-200",
      active
        ? "text-(--accent-700) bg-(--accent-100) scale-110 drop-shadow-[0_0_12px_var(--accent-glow)]"
        : "text-(--accent-700)/60 hover:text-(--accent-700)/80",
    ].join(" ");
  };

  return (
    <nav className="safe-mobile-nav pointer-events-none fixed inset-x-0 bottom-6 z-50 flex justify-center px-4">
      <div className="pointer-events-auto flex items-center justify-center gap-3 rounded-[28px] border border-violet-300/30 bg-white/30 bg-linear-to-br from-violet-50/40 to-violet-100/30 p-3 text-violet-900 shadow-[0_8px_24px_rgba(139,92,246,0.1)] backdrop-blur-md">
        <Link href="/dashboard" className={linkClass("/dashboard")} title="Dashboard">
          <Home className="h-6 w-6" strokeWidth={2} />
        </Link>

        <Link href="/library" className={linkClass("/library")} title="Library">
          <Library className="h-6 w-6" strokeWidth={2} />
        </Link>

        <Link href="/add-book" className={linkClass("/add-book")} title="Ajouter un livre">
          <Plus className="h-6 w-6" strokeWidth={2} />
        </Link>

        <Link href="/bookbesties" className={linkClass("/bookbesties")} title="Matchs">
          <Heart className="h-6 w-6" strokeWidth={2} />
        </Link>

        <Link href="/calendar" className={linkClass("/calendar")} title="Calendrier">
          <Calendar className="h-6 w-6" strokeWidth={2} />
        </Link>
      </div>
    </nav>
  );
}
